import { render, staticRenderFns } from "./TrafiklabWidgetPanel.vue?vue&type=template&id=0de1a357&scoped=true"
import script from "./TrafiklabWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TrafiklabWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TrafiklabWidgetPanel.vue?vue&type=style&index=0&id=0de1a357&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1a357",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de1a357')) {
      api.createRecord('0de1a357', component.options)
    } else {
      api.reload('0de1a357', component.options)
    }
    module.hot.accept("./TrafiklabWidgetPanel.vue?vue&type=template&id=0de1a357&scoped=true", function () {
      api.rerender('0de1a357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TrafiklabWidgetPanel.vue"
export default component.exports